import React, { useState } from 'react';
import { Link } from '@material-ui/core';
import DocumentDialog from 'components/DocumentDialog';

const LinkDocumentDialog = ({ title, alignLink, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Link color="inherit" variant="body2" align={alignLink} href="#" onClick={() => setOpen(true)}>
        {title}
      </Link>
      <DocumentDialog title={title} open={open} onClose={() => setOpen(false)}>
        {children}
      </DocumentDialog>
    </>
  );
};

export default LinkDocumentDialog;
